// extracted by mini-css-extract-plugin
export default {"modal":"_2hSGxDXl"};